import { render } from "./BasicDropFile.vue?vue&type=template&id=5e9288a4&scoped=true"
import script from "./BasicDropFile.vue?vue&type=script&lang=js"
export * from "./BasicDropFile.vue?vue&type=script&lang=js"

import "./BasicDropFile.vue?vue&type=style&index=0&id=5e9288a4&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9288a4"]])

export default __exports__